import React from "react";
import { Button, Input, Option, Select, Textarea } from "@material-tailwind/react";
import { convertToPresentableText } from "../../../utils/functions";
import { 
  BUSINESS_LEADS_ENUM, 
  DEAL_SIZES_ENUM, 
  LEVELS_ENUM, 
  NEGOTIATION_STAGES_ENUM 
} from "../../../utils/enums";
import { PlusIcon } from "lucide-react";

const OpportunityTab = ({ formData, handlers, arrayState }) => {
  const {
    handleInputChange,
    handleSelectChange,
    handleNestedInputChange,
    handleAddProduct,
    handleRemoveProduct,

  } = handlers;

  const {
    newProduct,
    setNewProduct,
  } = arrayState;

  return (
    <div className="space-y-4">
      <div className="border p-4 rounded-md">
        <h3 className="text-sm font-medium mb-3">Opportunity Details</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label="Opportunity Code"
            value={formData.opportunityDetails?.opportunityId || ''}
            onChange={(e) => handleNestedInputChange('opportunityDetails', 'opportunityId', e.target.value)}
          />
          <Select
            label="Estimated Deal Size"
            value={formData.opportunityDetails?.estimatedDealSize || ''}
            onChange={(value) => handleNestedInputChange('opportunityDetails', 'estimatedDealSize', parseFloat(value))}
          >
            {DEAL_SIZES_ENUM.map((stage, index) => (
              <Option key={index} value={stage}>
                PKR {convertToPresentableText(stage.split(':')[2])}
              </Option>
            ))}
          </Select>
          <Select
            label="Proposal Status"
            value={formData.opportunityDetails?.proposalStatus || ''}
            onChange={(value) => handleNestedInputChange('opportunityDetails', 'proposalStatus', value)}
          >
            {BUSINESS_LEADS_ENUM.map((status, index) => (
              <Option key={index} value={status}>
                {convertToPresentableText(status)}
              </Option>
            ))}
          </Select>
          <Select
            label="Negotiation Stage"
            value={formData.opportunityDetails?.negotiationStage || ''}
            onChange={(value) => handleNestedInputChange('opportunityDetails', 'negotiationStage', value)}
          >
            {NEGOTIATION_STAGES_ENUM.map((stage, index) => (
              <Option key={index} value={stage}>
                {convertToPresentableText(stage)}
              </Option>
            ))}
          </Select>
          <Input
            label="Projected Close Date"
            type="date"
            value={formData.opportunityDetails?.projectedCloseDate ? new Date(formData.opportunityDetails.projectedCloseDate).toISOString().split('T')[0] : ''}
            onChange={(e) => handleNestedInputChange('opportunityDetails', 'projectedCloseDate', e.target.value)}
          />
        </div>
        
        <div className="mt-4">
          <h4 className="text-sm font-medium mb-2">Add the Products/Services Customer is Interested In</h4>
          <div className="flex gap-2">
            <Input
              label="Add Product/Service"
              value={newProduct}
              onChange={(e) => setNewProduct(e.target.value)}
              className="flex-grow"
            />
            <Button variant="filled" className="rounded-full px-3" onClick={handleAddProduct}>
              <PlusIcon size={16} />
            </Button>
          </div>
          <div className="mt-2 flex flex-wrap gap-2">
            {formData.opportunityDetails?.productsInterested?.map((product, index) => (
              <div key={index} className="inline-flex items-center bg-blue-50 text-blue-700 rounded-full px-3 py-1 text-sm">
                {product}
                <button 
                  type="button" 
                  className="ml-2 text-blue-500 hover:text-blue-700"
                  onClick={() => handleRemoveProduct(index)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="flex gap-4 flex-col md:flex-row">
        <div className="w-full md:w-1/2">
          <Input
            label="Next Action"
            name="nextAction"
            value={formData.nextAction || ''}
            onChange={handleInputChange}
          />
        </div>
        <div className="w-full md:w-1/2">
          <Input
            label="Action Due Date"
            name="actionDueDate"
            type="date"
            value={formData.actionDueDate ? new Date(formData.actionDueDate).toISOString().split('T')[0] : ''}
            onChange={handleInputChange}
          />
        </div>
      </div>
<div className="border p-4 rounded-md">
      <div className="flex gap-4 flex-col md:flex-row justify-between items-center mb-4">
      <div className="w-full">
      <h3 className="text-sm font-medium mb-2">Follow up Details</h3>

      </div>
        <Select
          label="Follow-up Priority"
          className="w-full"
          value={formData.followUpPriority || LEVELS_ENUM[1]} // Default to medium
          onChange={(value) => handleSelectChange("followUpPriority", value)}
        >
          {LEVELS_ENUM.map((level, index) => (
            <Option key={index} value={level}>
              {convertToPresentableText(level)}
            </Option>
          ))}
        </Select>
      </div>
      
      <div className="w-full">
        <Textarea
          label="Follow-up Notes"
          name="followUpNotes"
          value={formData.followUpNotes || ''}
          onChange={handleInputChange}
        />
        </div>
      </div>      
    </div>
  );
};

export default OpportunityTab;